import { graphql } from 'src/gql'
import { GetTData } from 'src/gql/helpers'
import { useGraphQL } from 'src/hooks/useGraphQL'

const document = graphql(/* graphql */`
  query staffingAgencyDetailsById($id: MongoID!) {
    cat {
      distributionSubcategory{
        byId(_id: $id) {
          _id
          name
          status
          _status {
            _id
            name
            color
          }
          staffingAgency {
            sdvosb
            clearedFacility
            _clearedFacility {
              _id
              name
            }
          }
        }
      }
    }
  }
`)

type TData = GetTData<typeof document>
export type StaffingAgencyDetailsById = NonNullable<NonNullable<NonNullable<NonNullable<TData>['cat']>['distributionSubcategory']>['byId']>

const useStaffingAgencyDetailsById = (id: string): StaffingAgencyDetailsById | undefined => {
  const { data } = useGraphQL(document, { id }, {
    enabled: typeof id === 'string'
  })
  const distribution = data?.cat?.distributionSubcategory?.byId ?? undefined
  return distribution
}

export { useStaffingAgencyDetailsById, document as staffingAgencyDetailsByIdDocument }
